'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import Image from 'next/image';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import ParallaxBlock from '@components/ParallaxBlock';
import IslandCommonButton from '../IslandCommonButton';
import cn from './style.module.scss';
export default function HouseWelcome(props: any) {
  const { t } = props;
  return (
    <Stack component="section" className={cn.beachHouseWelcome}>
      <Box
        className={cn.beachWelcomeInner}
        sx={{
          backgroundImage: `url(${props.beachHouseWelcomeBackgroundImage.url})`,
        }}
      >
        <CommonContainer maxWidth={{ xs: '100%', md: '1320px' }} flexGrow={1}>
          <Box className={cn.beachWelcomeBody}>
            <Box className={cn.beachWelcomeContent}>
              <Box className={cn.beachWelcomeContent__heading}>
                <ParallaxText
                  variant="h2"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['beachHouseWelcomeHeading'])}
                </ParallaxText>
              </Box>
              <Box className={cn.beachWelcomeContent__description}>
                <Box className={cn.beachDescriptionText}>
                  <ParallaxText
                    variant="p"
                    animationType="slideInBottom"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(t['beachHouseWelcomeContent'])}
                  </ParallaxText>
                </Box>
                <Box className={cn.beachDescriptionButton}>
                  <ParallaxBlock animationType="zoomIn" animationDuration={500}>
                    <IslandCommonButton t={t} labelKey={t['actionButton']} />
                  </ParallaxBlock>
                </Box>
              </Box>
            </Box>
            <Box className={cn.beachWelcomeTheme}>
              <Box className={cn.beachThemeBlock}>
                <ParallaxBlock animationType="zoomIn" animationDuration={500}>
                  <Mobile>
                    <Image
                      src={props.beachHouseWelcomeThemeMobileBanner.url}
                      alt="House Welcome - Beach House Welcome Theme Mobile Banner"
                      width={768}
                      height={768}
                      unoptimized
                      quality={100}
                    />
                  </Mobile>
                  <Desktop>
                    <Image
                      src={props.beachHouseWelcomeThemeDesktopBanner.url}
                      alt="House Welcome - Beach House Welcome Theme Desktop Banner"
                      width={768}
                      height={768}
                      unoptimized
                      quality={100}
                    />
                  </Desktop>
                </ParallaxBlock>
              </Box>
            </Box>
          </Box>
        </CommonContainer>
        <Box
          className={cn.beachWelcomeBottomBackground}
          sx={{
            backgroundImage: `url(${props.beachHouseWelcomeBottomShadow.url})`,
          }}
        />
      </Box>
    </Stack>
  );
}
